import { useEffect, useRef } from 'react'

export default function Cursor() {
  const dotRef = useRef(null)
  const ringRef = useRef(null)
  const pos = useRef({ x: -100, y: -100 })
  const ringPos = useRef({ x: -100, y: -100 })
  const hovered = useRef(false)

  useEffect(() => {
    // Only show custom cursor on desktop
    const isTouchDevice = ('ontouchstart' in window) || navigator.maxTouchPoints > 0
    if (isTouchDevice) {
      document.body.style.cursor = 'auto'
      return
    }

    const move = (e) => {
      pos.current = { x: e.clientX, y: e.clientY }
    }
    window.addEventListener('mousemove', move)

    let raf
    const animate = () => {
      if (dotRef.current) {
        dotRef.current.style.left = pos.current.x + 'px'
        dotRef.current.style.top = pos.current.y + 'px'
      }
      if (ringRef.current) {
        ringPos.current.x += (pos.current.x - ringPos.current.x) * 0.12
        ringPos.current.y += (pos.current.y - ringPos.current.y) * 0.12
        ringRef.current.style.left = ringPos.current.x + 'px'
        ringRef.current.style.top = ringPos.current.y + 'px'
      }
      raf = requestAnimationFrame(animate)
    }
    raf = requestAnimationFrame(animate)

    const addHover = () => {
      hovered.current = true
      ringRef.current?.classList.add('hovered')
    }
    const removeHover = () => {
      hovered.current = false
      ringRef.current?.classList.remove('hovered')
    }

    const attachListeners = () => {
      document.querySelectorAll('a, button, .service-card, .prop-card, .why-card, .proj-item, .nav-link-item, .nav-cta, .prop-enquire, .svc-link, .btn-gold, .btn-outline').forEach(el => {
        el.addEventListener('mouseenter', addHover)
        el.addEventListener('mouseleave', removeHover)
      })
    }

    // Initial attach + watch for new elements
    attachListeners()
    const observer = new MutationObserver(attachListeners)
    observer.observe(document.body, { childList: true, subtree: true })

    return () => {
      window.removeEventListener('mousemove', move)
      cancelAnimationFrame(raf)
      observer.disconnect()
    }
  }, [])

  return (
    <>
      <div className="cursor-dot" ref={dotRef} />
      <div className="cursor-ring" ref={ringRef} />
    </>
  )
}
